<template>
<section class="container">
  <section :class="['topDiv',dataList.length == 0 ?'topDiv_none':'']">
    <section class="topDiv_item"  @click="select(1)">
        <span class="topDiv_item_span">{{couponName}}</span>
        <img  class="topDiv_item_icon" src="../../assets/images/icon_arrows_filter_normal.png"/>
    </section>
    <section class="topDiv_item" @click="select(2)">
        <span class="topDiv_item_span">{{bindMonth?bindMonth:'全部月份'}}</span>
        <img  class="topDiv_item_icon" src="../../assets/images/icon_arrows_filter_normal.png"/>
    </section>
  </section>
  <scroll
        :data="dataList"
        :allLoaded="allLoaded"
        :pulldown="true"
        @loadUp="loadup"
        @pulldown="pulldown"
        class="scroll_box"
      >
  <section class="record_list" v-if="dataList.length>0">
    <section class="list_item" v-for="(item,index) in dataList" :key="index">
      <section class="item_top">
        <section :class="['item_top_left',item.couponType == '1'?'item_top_free':'',item.couponType == '2'?'item_top_price':'',item.couponType == '4'?'item_top_discount':'']">
          <span class="type">{{item.couponType|couponType}}</span>
          <p v-if="item.couponType ==1"><i>1</i>次/张</p>
          <p v-else-if="item.couponType == 2"><span>{{item.diffAmount}}</span> 元/张</p>
          <p v-else-if="item.couponType == 4"><span>{{item.diffAmount | discountT(1)}}</span><i>.{{item.diffAmount | discountT(2)}}</i>折/张</p>
          <p v-else><span>{{item.diffAmount}}</span> 分钟/张</p>
        </section>
        <section class="item_top_right">
          <p>{{item.payAt}}</p>
        </section>
      </section>
      <section class="item_bottom">
        <section class="item_bottom_left">
          <p class="unit_price">券价格: {{item.price}}元/张</p>
          <p class="num">数量: x{{item.buyNumber}}</p>
        </section>
        <section class="item_bottom_right">
          <p>{{item.payAmount | priceFormat}}</p>
        </section>
      </section>
    </section>
  </section>
  <!-- 无数据 -->
  <section class="no_message" v-else>
    <p>还没有购券记录~</p>
  </section>
  </scroll>
  <mt-popup  v-model="popupVisible" position="bottom" class="mint-popup">
    <mt-picker class="picker" :slots="pickList" @change="onValuesChange" :visible-item-count="5" :show-toolbar="true" ref="picker" >
        <div class="picker_wrap">
            <div class="picker_btn" @click="popupVisible=false">取消</div>
            <div class="picker_btn2" @click="handleConfirm">确认</div>
        </div>
        </mt-picker>
    </mt-popup>
</section>
</template>
<script>
import {mapState} from 'vuex'
import { callSpaceUp } from '../../utils/api'
import util from '../../utils/util'
import Scroll from "../../components/scroll"
export default {
  name: 'buyRecord',
  props: {},
  components: {
      Scroll
  },
  filters: {
    couponType(val){
      if(val == 1){
        return '免费券'
      }else if(val == 2){
        return '金额券'
      }else if(val == 3){
        return '时间券'
      }else{
        return '折扣券'
      }
    },
    discountT(val,type){
      let num = (val/10).toFixed(1).toString();
      if(type == 1){
          return num.split(".")[0]
      }else{
          return num.split(".")[1]
      }
    }
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  data() {
    return {
      showPage:false,
      dataList:[],
      couponType:null,//券类型
      couponName:'全部券类型',
      bindMonth:null,//月份
      allLoaded:false,
      //弹框选择
      pickType:'',
      popupVisible:false,
      pickList:[],
      couponList:[{
        flex: 1,
        values:["全部券类型"],
        className: 'slot1',
        textAlign: 'center'
      }],
      monthList: [{
        flex: 1,
        values:["全部月份"],
        className: 'slot1',
        textAlign: 'center'
      }],
      couponTypeList:[],
      pageNo:1
    }
  },
  created(){
    this.queryParkCouponOrderList()
    this.queryMyCouponTypeList()
    this.queryMyBuyMonthList()
  },
  methods:{
    // 获取列表数据
    queryParkCouponOrderList(){
      util.showLoading()
      this.allLoaded = false;
      let params = {
        subProjectId:this.common.marketInfo.id,
        prkHeaderId:this.$route.query.prkHeaderId || '',//车场id
        phone:this.common.userInfo.phone || this.common.userInfo.account,
        pageSize:10,
        pageNo:this.pageNo,
        couponType:this.couponType,
        bindMonth:this.bindMonth,
        url: "/parking/rstParkCoupon/queryParkCouponOrderList"
      }
      callSpaceUp(params).then(res=>{
        util.hideLoading()
        console.log(res)
        this.showPage = true;
        if(res.res.code === 10000 && res.body && res.body.data){
          if(this.pageNo == 1){
            this.dataList = res.body.data || [];
          }else{
            this.dataList = this.dataList.concat(res.body.data)
          }
          if(res.body.data.length !== 10){
            this.allLoaded = true;
          }
        }else{
          util.showToast(res.res.msg)
        }
      })
    },
    // 获取优惠券类型
    queryMyCouponTypeList(){
      let params = {
        subProjectId:this.common.marketInfo.id,
        prkHeaderId:this.$route.query.prkHeaderId || '',//车场id
        phone:this.common.userInfo.phone || this.common.userInfo.account,
        url: "/parking/rstParkCoupon/queryMyCouponTypeList"
      }
      callSpaceUp(params).then(res=>{
        console.log(res)
        if(res.res.code === 10000 && res.body){
          let data = res.body.data || [];
          this.couponTypeList = data;
          data.forEach(item=>{
            this.couponList[0].values.push(item.couponTypeName)
          })
        }
      })
    },
    // 获取月份数据
    queryMyBuyMonthList(){
      let params = {
        subProjectId:this.common.marketInfo.id,
        prkHeaderId:this.$route.query.prkHeaderId || '',//车场id
        phone:this.common.userInfo.phone || this.common.userInfo.account,
        url: "/parking/rstParkCoupon/queryMyBuyMonthList"
      }
      callSpaceUp(params).then(res=>{
        console.log(res)
        if(res.res.code === 10000 && res.body){
          let data = res.body.data || [];
          data.forEach(item=>{
            this.monthList[0].values.push(item.monthValue)
          })
        }
      })
    },
    loadup(){
      if(this.allLoaded){
        return false;
      }
      this.pageNo ++ ;
      this.queryParkCouponOrderList();
    },
    pulldown(){
      this.pageNo = 1;
      this.queryParkCouponOrderList()
    },
    select(pickType){
         this.pickType=pickType;
         this.popupVisible=true;
         if(this.pickType==1){
             this.pickList = this.couponList;
         }else{
             this.pickList = this.monthList;
         }

     },
    onValuesChange (picker, values) {
      if (values[0] > values[1]) {
          picker.setSlotValue(1, values[0]);
      }
    },
    handleConfirm(){
      this.popupVisible = false
      var value =  this.$refs.picker.getValues()[0];
      if(this.pickType == 1){
        this.couponName = value;
        if(value != '全部券类型'){
          this.couponTypeList.forEach(item=>{
            if(value === item.couponTypeName){
              this.couponType = item.couponTypeValue
            }
          })
        }else{
          this.couponType = null;
        }
      }else{
        if(value != '全部月份'){
          this.bindMonth = value
        }else{
          this.bindMonth = null;
        }
      }
      this.queryParkCouponOrderList()
     },
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.container{
  height:100vh;
  display: flex;
  flex-direction: column;
  background:#eee;
}
.topDiv{
    width: 100%;
    height: 88px;
    flex-direction: row;
    background:rgba(248,248,248,1);
    display: flex;
    .topDiv_item{
      height: 88px;
      width: 50%;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      display: flex;
      .topDiv_item_span{
        height:40px;
        font-size:28px;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:40px;
      }
      .topDiv_item_icon{
        width: 24px;
        height: 24px;
        margin-left: 16px;
        display: flex;
      }
    }
}
.topDiv_none{
  background:#fff;
}
// 券列表
.record_list{
  flex:1;
}
.list_item{
  margin:20px;
  height:180px;
  padding:28px;
  box-sizing: border-box;
  background:rgba(255,255,255,1);
  border-radius:8px;
  .flex(column);
  justify-content: space-between;
  .item_top{
    width:100%;
    .flex();
    justify-content: space-between;
    .item_top_left{
      .flex();
      .type{
        display: block;
        width:100px;
        height:44px;
        background:rgba(229,243,255,1);
        border-radius:22px;
        text-align: center;
        line-height: 44px;
        font-size:24px;
        color:rgba(0,135,255,1);
        margin-right:20px;
      }
      p{
        font-size:26px;
        color:rgba(51,51,51,1);
        line-height:50px;
        span{
          font-size:36px;
        }
        i{
          font-style: normal;
          // font-weight:bold;
          font-size:36px;
          display: inline-block;
          margin-right:8px;
        }
      }
    }
    .item_top_price{
      .type{
        background:rgba(255,245,229,1);
        color:rgba(255,155,0,1);
      }
    }
    .item_top_discount{
      .type{
        background:rgba(254,235,238,1);
        color:rgba(252,63,86,1);
      }
    }
    .item_top_free{
      .type{
        background:rgba(231,248,242,1);
        color:rgba(22,188,132,1);
      }
    }
    .item_top_right{
      font-size:26px;
      color:rgba(153,153,153,1);
      line-height:40px;
    }
  }
  .item_bottom{
    .flex();
    width:100%;
    justify-content: space-between;
    align-items: center;
    .item_bottom_left{
      .flex();
      p{
        font-size:26px;
        color:rgba(102,102,102,1);
        line-height:40px;
        position: relative;
        &.unit_price{
          padding-right:40px;
          margin-right:40px;
          &:after{
            content:'';
            position: absolute;
            right:0;top:6px;
            width:2px;
            height:28px;
            background:rgba(234,234,234,1);
          }
        }
      }
    }
    .item_bottom_right{
      p{
        font-size:32px;
        font-weight:bold;
        color:rgba(51,51,51,1);
        line-height:40px;
      }
    }
  }
}
.no_message{
  margin-top:80px;
  .flex(column);
  justify-content: center;
  align-items: center;
  p{
    font-size:28px;
    color:#999;
    line-height:40px;
  }
}
</style>
